window.mmajaxcart = {
  BogoHandler: function(productArray, quantity) {
    Shopify.removeQueue = [];
    Shopify.removeAlong = function() {
      if (Shopify.removeQueue.length) {
        var request = Shopify.removeQueue.shift();
        Shopify.removeItem(request.variantId, request.quantity, Shopify.removeAlong);
      }
      else {
        mmajaxcart.AjaxcartRender();
        $.getJSON('/cart.js', function(cart) {
          var CartCount = cart.item_count;        
          $('.mm-cart-count').html(CartCount);
        })
      }
    }
    Shopify.removeItem = function(id, qty, callback) {
      var params = {
        quantity: qty,
        id: id
      };
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: params,
        success: function(){
          if(typeof callback === 'function'){
            callback();
          }
        },
        error: function(){}
      });
    }
    function remove_items(variantID, quantity) {
      Shopify.removeQueue.push({
        variantId: variantID,
        quantity: quantity
      });
    }
    $.each(productArray, function(key, value) {          
      remove_items(value, quantity);
    });
    Shopify.removeAlong();
  },  
  AjaxcartOpen: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.addClass('mm-no-scroll');
    ajaxCart.addClass('has--opened');      
    ajaxOverlay.addClass('has--active');
  },
  AjaxcartClose: function() {
    var body = $('body'),
        ajaxCart = $('.mm-ajaxcart'),           	
        ajaxOverlay = $('.mm-ajaxcart-overlay');

    body.removeClass('mm-no-scroll');
    ajaxCart.removeClass('has--opened');      
    ajaxOverlay.removeClass('has--active');       
  },
  AjaxcartRender: function() {
    
    /*
     * FREEBIE PRODUCT ADD
     */    
    if(false == true){
      $.getJSON('/cart.js', function(cart) {
        var cartSubtotal = (cart.total_price) / 100;
        var freebieTotal = "6000";        
        var Variant = $('.mm-ajaxcart').attr('data-gift-variant');

        if(cartSubtotal >= freebieTotal){
          var freeGiftAdded = false;
          for(i=0; i < cart.items.length; i++){
            if(cart.items[i].variant_id == Variant){
              freeGiftAdded = true;
              return;
            }
          }
          if(freeGiftAdded == false){
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data : {
                id: parseInt(Variant),
                quantity: 1,
                properties: {'freeGift':'free_gift'}
              },
              dataType: 'json',
              success: function(cart) {
                $.get('/cart?view=mm-ajax', function(cart){
                  $('.mm-ajaxcart').html(cart);
                })
              }
            }); 
          }
        }
      });
    } 
   $.get('/cart?view=mm-ajax', function(cart){
      $('.mm-ajaxcart').html(cart);
//         var order_value = $("#special-price").val();
//       console.log(order_value);
//       !function(){var e,t,n,i=function(e){e(document).ready(function(){e(".kloc-redemption-area").after('<div class="order-summary__section order-summary__section--loyalty"><form class="mbq-form edit_checkout animate-floating-labels" action="#" accept-charset="UTF-8"></form></div>');var t={};t.Form={init:function(e){var t=e.element;this.setEl(t),this.render(1)},setEl:function(t){this.el=e(t),this.el.on("submit",this.submitHandler.bind(this))},applyDiscount:function(t){var n=e("#checkout_reduction_code");e(".order-summary__section--discount > form");n.val(t),e(".order-summary__section--discount .field__input-btn").removeAttr("disabled").removeClass("btn--disabled").click()},currentStep:1,currentData:{},$currentStep:function(){return this.el.find(".step")},setErrorInCurrentStep:function(e){var t=this.$currentStep(),n=t.find(".__mbq_error");t.find(".field").addClass("field--error");n.html('<p class="field__message field__message--error">'+e+"</p>")},nextStep:function(){this.currentStep=this.currentStep+1,this.render(this.currentStep)},reset:function(){},disableStepField:function(e){e.find("input").attr("disabled","disabled")},enableStepField:function(e){e.find("input").removeAttr("disabled")},submitHandler:function(e){switch(e.preventDefault(),e.stopPropagation(),this.disableStepField(this.$currentStep()),this.currentStep){case 1:this.step1SubmitHandler(this.$currentStep());break;case 2:this.step2SubmitHandler(this.$currentStep());break;case 3:this.step3SubmitHandler(this.$currentStep())}},render:function(e,t){var n;switch(e){case 1:n=this.step1View(t);break;case 2:n=this.step2View(this.currentData);break;case 3:n=this.step3View(this.currentData);break;case 4:n=this.step4View(this.currentData),this.applyDiscount(this.currentData.redemption.discount_code)}this.el.html(n)},step1SubmitHandler:function(t){var n=t.find("#checkout_loyalty_phonenumber").val();this.currentData.phoneNumber=n,that=this,e.ajax({url:"/apps/klocmobiquest/shopper?phone_number="+n,success:function(e){that.currentData.loyaltyPoints=e.shopper.loyalty_points,that.nextStep()},dataType:"json",error:function(e,t,n){that.enableStepField(that.$currentStep()),that.setErrorInCurrentStep("The phone number is invalid. Can you correct the number or enter a new one?")}})},step2SubmitHandler:function(t){var n=t.find("#checkout_loyalty_redeem").val();this.currentData.pointsToRedeem=n,that=this,e.ajax({url:"/apps/klocmobiquest/shopper/redemptions?phone_number="+this.currentData.phoneNumber,method:"POST",data:JSON.stringify({redemption:{points:n,order_value: order_value }}),dataType:"json",contentType:"application/json",success:function(e){that.currentData.redemption=e.redemption,that.nextStep()},error:function(e,t,n){that.enableStepField(that.$currentStep()),that.setErrorInCurrentStep(e.responseJSON.errors.join(","))}})},step3SubmitHandler:function(t){var n=t.find("#checkout_loyalty_otp").val();this.currentData.otp=n,that=this,e.ajax({url:"/apps/klocmobiquest/shopper/redemptions/"+this.currentData.redemption.id+"/verify?phone_number="+this.currentData.phoneNumber+"&otp="+this.currentData.otp,method:"POST",dataType:"json",success:function(e){that.currentData.redemption=e.redemption,that.nextStep()},error:function(e,t,n){that.enableStepField(that.$currentStep()),that.setErrorInCurrentStep(e.responseJSON.errors.join(","))}})},step1View:function(t){return e('<div class="fieldset step">  <div class="field">    <h3>Redeem your loyalty points</h3>    <div class="field__message">Value of each point is ₹1</div>  </div>  <div class="field">    <div class="field__input-btn-wrapper">      <div class="field__input-wrapper">        <label class="field__label field__label--visible" for="checkout_loyalty_points">Enter your phone number to redeem the points</label>        <input style="width: -webkit-fill-available;" placeholder="Enter your phone number to redeem the points" class="field__input" autocomplete="off" aria-required="true" size="30" type="text" name="checkout_loyalty_phonenumber" id="checkout_loyalty_phonenumber">    <button type="submit" class="cart-popup__cta-link btn btn--secondary-accent btn flip-button btn wide">  <span class="btn__content visually-hidden-on-mobile">Next</span></button>  </div>                          </div>    <span class="__mbq_error"></span>  </div></div>')},step2View:function(t){t.phoneNumber;var n=t.loyaltyPoints,i=e('<div class="fieldset step">  <div class="field">    <h3>Redeem your loyalty points</h3>    <div class="field__message">Value of each point is ₹1</div>  </div>  <div class="field">    <div class="field__message">      You have      <strong>        <span class="loyaltypoints"></span>      </strong>      points left.<br/>      </br>    </div>    <div class="field__input-btn-wrapper">      <div class="field__input-wrapper">        <label class="field__label field__label--visible" for="checkout_loyalty_redeem">Enter number of points to redeem</label>        <input style="width: -webkit-fill-available;" placeholder="Enter number of points to redeem" class="field__input" data-discount-field="true" autocomplete="off" aria-required="true" size="30" type="text" name="checkout_loyalty_redeem" id="checkout_loyalty_redeem">   <button type="submit" class="cart-popup__cta-link btn btn--secondary-accent btn flip-button btn wide"><span class="btn__content visually-hidden-on-mobile">Next</span> </button>   </div>     </div>    <span class="__mbq_error"></span>  </div></div>');return i.find(".loyaltypoints").html(n),i},step3View:function(t){t.phoneNumber;var n=t.loyaltyPoints,i=t.pointsToRedeem,s=e('  <div class="fieldset step3 step">  <div class="field">    <h3>Redeem your loyalty points</h3>    <div class="field__message">Value of each point is ₹1</div>  </div>    <div class="field">      <div class="field__message">        You have <strong><span class="loyaltypoints"></span></strong> points left.\t     <br/>You are redeeming <strong><span class="pointstoredeem"></span></strong>. You will receive an OTP on your mobile number.<br/>      </br>\t   </div>      <div class="field__input-btn-wrapper">          <div class="field__input-wrapper"><label class="field__label field__label--visible" for="checkout_loyalty_otp">Enter OTP</label>            <input style="width: -webkit-fill-available;" placeholder="Enter OTP" class="field__input" data-discount-field="true" autocomplete="off" aria-required="true" size="30" type="text" name="checkout_loyalty_otp" id="checkout_loyalty_otp"> <button type="submit" class="cart-popup__cta-link btn btn--secondary-accent btn flip-button btn wide">          <span class="btn__content visually-hidden-on-mobile">Next</span> </button>  </div>  </div>    <span class="__mbq_error"></span>    </div>  </div>');return s.find(".loyaltypoints").html(n),s.find(".pointstoredeem").html(i+" points"),s},step4View:function(t){var n=t.redemption.discount_code,i=e('<div style="class="fieldset step4 step">  <div class="field">    <h3>Redeem your loyalty points</h3>    <div class="field__message">Value of each point is ₹1</div>  </div>  <div class="field">    <div class="field__message">      <h2>Redemption Code: <strong><span class="discountcode"></span></strong></h2>      <br/>      <p>The code has been applied and is for single use only! If not now, save it and use it later.</p>    </div>  </div></div>');console.log(n);applyDiscountCode(n);return i.find(".discountcode").html(n),i}},t.Form.init({element:".mbq-form"})})};"undefined"==typeof jQuery||parseFloat(jQuery.fn.jquery)<3?(e="//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js",t=function(){jQuery191=jQuery.noConflict(!0),i(jQuery191)},(n=document.createElement("script")).type="text/javascript",n.readyState?n.onreadystatechange=function(){"loaded"!=n.readyState&&"complete"!=n.readyState||(n.onreadystatechange=null,t())}:n.onload=function(){t()},n.src=e,document.getElementsByTagName("head")[0].appendChild(n)):i(jQuery)}();
//       var cart_value = $("#special-price").val();
//       var discountCode;
//       document.getElementById("myBtn").addEventListener("click", function(){
//     console.log("Cart Value---- ", cart_value)
//     let couponCode = document.getElementById("coupon").value;
//     $.ajax("/apps/klocmobiquest/tests/index",{data:{value: couponCode, shop: Shopify.shop, order_value: order_value},
//         method: "POST",
//         dataType: "json",
//         error: function(response, status, xhr) {
//         },
//         success: function(data) {
//           var getData = data;
//           if (getData.response && getData.response.GET_PROMOTIONAL_COUPON_VALIDATION_INFOResult.output.minimum_amt.length > 0){
//            var minAmount = getData.response.GET_PROMOTIONAL_COUPON_VALIDATION_INFOResult.output.minimum_amt;
//            discountCode = getData.coupon_code;
//             console.log("Min AMt ------- ", minAmount)
//           } else {
//             var minAmount = 0
//             }
//           if (getData.response == 'expired'){
//             document.getElementById("test").innerHTML = 'Your coupon code has expired';
//           }
//           if (!getData.response){
//             //let msg = getData.response.GET_PROMOTIONAL_COUPON_VALIDATION_INFOResult.message
//             document.getElementById("test").innerHTML = "Not a valid coupon code";
//           }
//           else if( parseInt(cart_value) >= parseInt(minAmount) ){
//             console.log("Came to correct part")
//             let couponValue = getData.response.GET_PROMOTIONAL_COUPON_VALIDATION_INFOResult.output.coupon_value;
//             let couponType = getData.response.GET_PROMOTIONAL_COUPON_VALIDATION_INFOResult.output.value_type;
//             if (couponType == 'percent'){
//               var discountAmount = order_value * couponValue/100;
//               var finalAmount = order_value - discountAmount;
//               document.getElementById("test").innerHTML = "You will get "+couponValue+" % discount";
// 			  myFunction(discountCode)
//             }
//             else{
//               var finalAmount = order_value - couponValue;
//               document.getElementById("test").innerHTML = "You will get "+couponValue+" RS discount.";
// 			  myFunction(discountCode)
//             }
//           }
//           else{
//                           console.log("Came to else part", order_value)
//             document.getElementById("test").innerHTML = `Minimun cart value should be ${minAmount} rupees`
//           }
//         },
//         async: false
//       });
//   });
//   function myFunction(discountCode){
//     window.location.href = `/checkout?discount=${discountCode}`;
//   }
//   function applyDiscountCode(discount_code){
//     window.location.href = `/checkout?discount=${discount_code}`;
//   }
    })
  },
  AjaxcartChangeHandler: function(data) {    
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: data,
      success: function (cart) {
      
        //BOGO OFFER HANDLER STARTS
        var items = cart.items,
            bogoProducts = [];
        
        $.each(items, function(key, item) {
          if(item.properties) {
            if(item.properties._Offer) {
              var parentVariantId = item.properties._ParentVariant;
              bogoProducts.push({parentVariantId: parentVariantId, bogoVariantId: item.key, bogoProductQuantity: item.quantity})
            }
          }                                
        });
        
        var bogoProductsToRemove = [];
        var bogoProductsToUpdate = [];
        if(bogoProducts.length) {                                
          for(var i=0; i<bogoProducts.length; i++) {
            let parentVariantIdExists = false;

            $.each(items, function(key, item) {
              if(item.id === parseInt(bogoProducts[i].parentVariantId)) {
                parentVariantIdExists = true;
                var parentProductQuantity = item.quantity;

                if(parentProductQuantity !== bogoProducts[i].bogoProductQuantity) {            
                  bogoProductsToUpdate.push({
                    id: [bogoProducts[i].bogoVariantId],
                    quantity: parentProductQuantity
                  })
                }
              }
            })
            
            if(!parentVariantIdExists) {
              bogoProductsToRemove.push(bogoProducts[i].bogoVariantId);              
            }
          }
        }
        
        //If main product doesn't exist remove offer product
        if(bogoProductsToRemove.length) {
          mmajaxcart.BogoHandler(bogoProductsToRemove, 0);
        }
        //If offer product quantity doesn't match with main, update
        if(bogoProductsToUpdate.length) {
          $.each(bogoProductsToUpdate, function(index, item) {
            mmajaxcart.BogoHandler(item.id, item.quantity);
          })
        }        
        //BOGO OFFER HANDLER ENDS
        
        mmajaxcart.AjaxcartRender();
        var CartCount = cart.item_count;        
        $('.mm-cart-count').html(CartCount);
      }
    });
  },
  AjaxcartQuantityHandler: function() {
    $(document).on('click', '.quantity-plus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) + p;
      $(this).parent().find('.quantity-input').val(u).trigger('change');
      $('.mm-cart-count').html(u);
    })
    $(document).on('click', '.quantity-minus', function() {
      let q = $(this).parent().find('.quantity-input').val(),
          i = 1,
          p = parseInt(i),
          u = parseInt(q) - p;
      $(this).parent().find('.quantity-input').val(u).trigger('change');
      $('.mm-cart-count').html(u);
    })
    $(document).on('change', '.quantity-input', function() {
      var UpdatedQuantity = parseInt($(this).val()),
          QuantityLine = parseInt($(this).attr('data-line')),
          params = { quantity: UpdatedQuantity, line: QuantityLine };
      
      mmajaxcart.AjaxcartChangeHandler(params);
      $('.mm-cart-count').html(params.quantity);
    })
    $(document).on('click', '.mm-ajaxcart-remove-item', function() {
      var RemoveLine = parseInt($(this).attr('data-line')),
          params = { quantity: 0, line: RemoveLine };

      mmajaxcart.AjaxcartChangeHandler(params);
      $('.mm-cart-count').html(params.quantity);
    })
  }
}

$(document).ready(function() { 
  $(document).on('click', '.mm-ajaxcart-open', function(e) {
  	e.preventDefault();
    mmajaxcart.AjaxcartOpen();
    mmajaxcart.AjaxcartRender();
  })
  
  $(document).on('click', '.mm-ajaxcart-close, .mm-ajaxcart-overlay', function(e) {
    e.preventDefault();
    mmajaxcart.AjaxcartClose();
  });
  
  mmajaxcart.AjaxcartRender();
  mmajaxcart.AjaxcartQuantityHandler();

  //AJAX ADD TO CART PDP
  $(document).on('click', '.product-form button[name="add"]', function(e) {
    e.preventDefault();

    var formData = $('form.product-form').serializeArray();
    
    function ajaxAdd(data) {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: data,
        success: function () {
          mmajaxcart.AjaxcartRender();
          setTimeout(function () {
            mmajaxcart.AjaxcartOpen();
          }, 500);

          //Call Cart JSON
          $.getJSON('/cart.js', function(cart) {
            var currentCartCount = cart.item_count;
            if (currentCartCount >= 0) {
              $('#CartCount').removeClass('hide');	
            } else {
              $('#CartCount').addClass('hide');
            }
            $('.mm-cart-count').html(currentCartCount);
          });
        }
      });
    }
    
    /* Search for original variant id */
    function search(name, array){
      for (var i=0; i < array.length; i++) {
        if (array[i].name === name) {
          return array[i];
        }
      }
    }    
    var resultObject = search("id", formData);
    
    if($(this).attr('data-bogo-variant')) {      
      var AddParam = {
        items: [
          {
            quantity: 1,
            id: parseInt($(this).attr('data-bogo-variant')),
            properties: {
              '_Offer': 'BOGO',
              '_ParentVariant': resultObject.value
            }
          }         
        ]
      }
      
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: formData,
        success: function () {
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: AddParam,
            success: function () {
              mmajaxcart.AjaxcartRender();
              setTimeout(function () {
                mmajaxcart.AjaxcartOpen();
              }, 500);

              //Call Cart JSON
              $.getJSON('/cart.js', function(cart) {
                var currentCartCount = cart.item_count;
                if (currentCartCount >= 0) {
                  $('#CartCount').removeClass('hide');	
                } else {
                  $('#CartCount').addClass('hide');
                }
                $('.mm-cart-count').html(currentCartCount);
              });
            }
          });
        }
      });
    } 
    else {
      ajaxAdd(formData);
    }
  });
  
  
  //AJAX ADD PLP
  $(document).on('click', '.js-ajax-add', function(e) {
    var variant = $(this).attr('data-variant');

    var AddParam = {
      id: parseInt(variant),
      quantity: 1
    }
        
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: AddParam,
      success: function () {
        mmajaxcart.AjaxcartRender();
        setTimeout(function () {
          mmajaxcart.AjaxcartOpen();
        }, 500);

        //Call Cart JSON
        $.getJSON('/cart.js', function(cart) {
          var currentCartCount = cart.item_count;
          if (currentCartCount >= 0) {
            $('#CartCount').removeClass('hide');	
          } else {
            $('#CartCount').addClass('hide');
          }
          $('.mm-cart-count').html(currentCartCount);
        });
      }
    });
  });
})